import {
  ButtonsDropdownOption,
  Dropdown,
  dropdownTypes,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { Ellipsis } from "lucide-react";
import { bool, func } from "prop-types";
import { useSelector } from "react-redux";
import { selectIsLockedByAnotherUser } from "slices/proposalOutline/selectors";

import useDeleteOutline from "../../hooks/useDeleteOutline";
import classes from "./ActionsDropdownButton.module.scss";
import GenerateOutlineButton from "./GenerateOutlineButton";
import { handleStopPropagation } from "./utils";

const ActionsDropdownButton = ({
  isArchived,
  llmAvailable,
  onSubmitRegenerate,
}) => {
  const onClickDelete = useDeleteOutline();

  const isLockedByOtherUser = useSelector(selectIsLockedByAnotherUser);

  return (
    <Dropdown
      onOpenChange={handleStopPropagation}
      type={dropdownTypes.buttons}
      propsObject={{
        buttonVariant: NewButtonVariant.l2,
        title: "Outline Actions",
        hideArrowIcon: true,
        leftIcon: <Ellipsis size={16} />,
        options: [
          <GenerateOutlineButton
            key="regenerate-outline-option"
            className={classes.regenerateBtn}
            content="Regenerate Outline"
            onSubmitDocuments={onSubmitRegenerate}
            variant={NewButtonVariant.l5}
            llmAvailable={llmAvailable}
          />,
          <ButtonsDropdownOption
            disabled={isArchived || isLockedByOtherUser}
            key="delete-outline-option"
            content="Delete Outline"
            onClick={onClickDelete}
          />,
        ],
        closeOnMouseLeave: true,
      }}
    />
  );
};

ActionsDropdownButton.propTypes = {
  isArchived: bool,
  llmAvailable: bool,
  onSubmitRegenerate: func.isRequired,
};

export default ActionsDropdownButton;
